import { createActionGroup, props } from '@ngrx/store';
import { BatchState } from '@batch/state/batch.reducer';

export const BatchActions = createActionGroup({
  source: 'Batch',
  events: {
    'Update table paginator': props<{ tablePagination: BatchState['tablePagination'] }>(),
  }
});
